/*
 * OrdersPage Messages
 *
 * This contains all the text for the OrdersPage container.
 */

import { defineMessages } from 'react-intl';

export const scope = 'app.containers.OrdersPage';

export default defineMessages({
  header: {
    id: `${scope}.header`,
    defaultMessage: 'This is the OrdersPage container!',
  },
  to: {
    id: `${scope}.to`,
    defaultMessage: 'Nhà cung cấp',
  },
  exportCSV: {
    id: `${scope}.exportCSV`,
    defaultMessage: 'Xuất CSV',
  },
  product: {
    id: `${scope}.product`,
    defaultMessage: 'Sản phẩm',
  },
  notes: {
    id: `${scope}.notes`,
    defaultMessage: 'Ghi chú',
  },
  by: {
    id: `${scope}.by`,
    defaultMessage: 'Người mua',
  },
  status: {
    id: `${scope}.status`,
    defaultMessage: 'Trạng thái',
  },
  allStatus: {
    id: `${scope}.allStatus`,
    defaultMessage: 'Tất cả trạng thái',
  },
  clearFilter: {
    id: `${scope}.clearFilter`,
    defaultMessage: 'Xóa lọc',
  },
  pendingStatus: {
    id: `${scope}.pendingStatus`,
    defaultMessage: 'Đang xử lý',
  },
  waitingDeliveryStatus: {
    id: `${scope}.waitingDeliveryStatus`,
    defaultMessage: 'Chờ giao',
  },
  deliveredStatus: {
    id: `${scope}.deliveredStatus`,
    defaultMessage: 'Đã giao',
  },
  cancelledStatus: {
    id: `${scope}.cancelledStatus`,
    defaultMessage: 'Đã huỷ',
  },
  selectStatus: {
    id: `${scope}.selectStatus`,
    defaultMessage: 'Chọn trạng thái',
  },
  viewDetails: {
    id: `${scope}.viewDetails`,
    defaultMessage: 'Xem chi tiết',
  },

  PENDING_APPROVAL: {
    id: `${scope}.status.PENDING_APPROVAL`,
    defaultMessage: 'Đang chờ duyệt',
  },
  APPROVAL_DISAPPROVED: {
    id: `${scope}.status.APPROVAL_DISAPPROVED`,
    defaultMessage: 'Không duyệt',
  },
  PENDING_ACCEPTANCE: {
    id: `${scope}.status.PENDING_ACCEPTANCE`,
    defaultMessage: 'Chờ chấp nhận',
  },
  ACCEPTED: {
    id: `${scope}.status.ACCEPTED`,
    defaultMessage: 'Đã chấp nhận',
  },
  CANCELED: {
    id: `${scope}.status.CANCELED`,
    defaultMessage: 'Đã huỷ',
  },
  DECLINED: {
    id: `${scope}.status.DECLINED`,
    defaultMessage: 'Đã từ chối',
  },
  SENT: {
    id: `${scope}.status.SENT`,
    defaultMessage: 'Đã gửi email',
  },
  DELIVERED: {
    id: `${scope}.status.DELIVERED`,
    defaultMessage: 'Đã giao',
  },
  IN_PROGRESS: {
    id: `${scope}.status.IN_PROGRESS`,
    defaultMessage: 'Đang xử lý',
  },
  PENDING_DELIVERY: {
    id: `${scope}.status.PENDING_DELIVERY`,
    defaultMessage: 'Chờ giao hàng',
  },
  DELIVERING: {
    id: `${scope}.status.DELIVERING`,
    defaultMessage: 'Đang giao',
  },
  DELIVERY_IN_PROGRESS: {
    id: `${scope}.status.DELIVERY_IN_PROGRESS`,
    defaultMessage: 'Đang giao',
  },
  orderTime: {
    id: `${scope}.orderTime`,
    defaultMessage: 'Ngày đặt hàng',
  },
  deliveryTime: {
    id: `${scope}.deliveryTime`,
    defaultMessage: 'Ngày giao hàng',
  },
  declineReason: {
    id: `${scope}.declineReason`,
    defaultMessage: 'Lý do từ chối',
  },
  rawTotal: {
    id: `${scope}.rawTotal`,
    defaultMessage: 'Tiền hàng',
  },
  total: {
    id: `${scope}.total`,
    defaultMessage: 'Tổng tiền (Sau VAT)',
  },
  discount: {
    id: `${scope}.discount`,
    defaultMessage: 'Giảm giá',
  },
  deliveryToday: {
    id: `${scope}.deliveryToday`,
    defaultMessage: 'Giao hàng hôm nay',
  },
  ordersToday: {
    id: `${scope}.ordersToday`,
    defaultMessage: 'Đơn hàng hôm nay',
  },
  pendingApprovalOrders: {
    id: `${scope}.pendingApprovalOrders`,
    defaultMessage: 'Đơn hàng chờ duyệt',
  },
  recentOrders: {
    id: `${scope}.recentOrders`,
    defaultMessage: 'Đơn hàng gần đây',
  },
  activityReport: {
    id: `${scope}.activityReport`,
    defaultMessage: 'Báo cáo hoạt động',
  },
  totalPurchase: {
    id: `${scope}.totalPurchase`,
    defaultMessage: 'Giá trị đã mua',
  },
  orderHistory: {
    id: `${scope}.orderHistory`,
    defaultMessage: 'Đơn hàng',
  },
  allSupplier: {
    id: `${scope}.allSupplier`,
    defaultMessage: 'Tất cả nhà cung cấp',
  },
  selectSupplier: {
    id: `${scope}.selectSupplier`,
    defaultMessage: 'Chọn nhà cung cấp',
  },
  orderDate: {
    id: `${scope}.orderDate`,
    defaultMessage: 'Ngày đặt',
  },
  deliveryDate: {
    id: `${scope}.deliveryDate`,
    defaultMessage: 'Ngày giao',
  },
  clear: {
    id: `${scope}.clear`,
    defaultMessage: 'Xoá',
  },
  apply: {
    id: `${scope}.apply`,
    defaultMessage: 'Đồng ý',
  },
  cancelOrder: {
    id: `${scope}.cancelOrder`,
    defaultMessage: 'Huỷ đơn hàng',
  },
  cancelOrderMessage: {
    id: `${scope}.cancelOrderMessage`,
    defaultMessage: 'Bạn có chắc muốn huỷ đơn hàng này?',
  },
  hasNoOrders: {
    id: `${scope}.hasNoOrders`,
    defaultMessage: 'Không có đơn hàng nào',
  },
  totalItems: {
    id: `${scope}.totalItems`,
    defaultMessage: 'Tổng số sản phẩm',
  },
  confirmOrder: {
    id: `${scope}.confirmOrder`,
    defaultMessage: 'Điều chỉnh thực nhận',
  },
  receiveOrder: {
    id: `${scope}.receiveOrder`,
    defaultMessage: 'Đã nhận hàng',
  },
  editOrder: {
    id: `${scope}.editOrder`,
    defaultMessage: 'Thay đổi đơn hàng',
  },
  actualQuantity: {
    id: `${scope}.actualQuantity`,
    defaultMessage: 'Số lượng thực tế',
  },
  editQuantity: {
    id: `${scope}.editQuantity`,
    defaultMessage: 'Cập nhật số lượng',
  },
  orderQuantity: {
    id: `${scope}.orderQuantity`,
    defaultMessage: 'Số lượng đã đặt',
  },
  acceptedQuantity: {
    id: `${scope}.acceptedQuantity`,
    defaultMessage: 'Số lượng đã nhận',
  },
  creator: {
    id: `${scope}.creator`,
    defaultMessage: 'Người đặt',
  },
  storeName: {
    id: `${scope}.storeName`,
    defaultMessage: 'Tên cửa hàng',
  },
  declineOrderMessage: {
    id: `${scope}.declineOrderMessage`,
    defaultMessage: 'Bạn có chắc muốn từ chối đơn hàng này?',
  },
  declineThisOrder: {
    id: `${scope}.declineThisOrder`,
    defaultMessage: 'Không duyệt đơn hàng này',
  },
  confirmDeliveryOrderMessage: {
    id: `${scope}.confirmDeliveryOrderMessage`,
    defaultMessage: 'Vẫn chưa đến thời gian giao hàng, bạn có chắc muốn xác nhận đơn hàng đã được nhận?',
  },
  thisIsReDeliveryOrder: {
    id: `${scope}.thisIsReDeliveryOrder`,
    defaultMessage: 'Đây là đơn hàng được giao bù',
  },
  thisIsSampleOrder: {
    id: `${scope}.thisIsSampleOrder`,
    defaultMessage: 'Đây là đơn hàng mẫu',
  },
  thisIsGiftOrder: {
    id: `${scope}.thisIsGiftOrder`,
    defaultMessage: 'Đây là đơn hàng quà tặng',
  },
  thisIsEmployeeOrder: {
    id: `${scope}.thisIsEmployeeOrder`,
    defaultMessage: 'Đây là đơn hàng nhân viên',
  },
  transferNote: {
    id: `${scope}.transferNote`,
    defaultMessage: 'Chỉ thanh toán sau khi giao hàng hoàn tất',
  },
  transferInstruction: {
    id: `${scope}.transferInstruction`,
    defaultMessage: 'Xem Hướng Dẫn Chuyển Khoản',
  },
  transferInstructions: {
    id: `${scope}.transferInstructions`,
    defaultMessage: 'Hướng Dẫn Chuyển Khoản',
  },
  accountName: {
    id: `${scope}.accountName`,
    defaultMessage: 'Tên tài khoản',
  },
  accountNumber: {
    id: `${scope}.accountNumber`,
    defaultMessage: 'Số tài khoản',
  },
  bank: {
    id: `${scope}.bank`,
    defaultMessage: 'Ngân hàng',
  },
  totalAmount: {
    id: `${scope}.totalAmount`,
    defaultMessage: 'Tổng số tiền',
  },
  tranferMessage: {
    id: `${scope}.tranferMessage`,
    defaultMessage: 'Nội dung chuyển khoản',
  },
  importantNotes: {
    id: `${scope}.importantNotes`,
    defaultMessage: 'Ghi chú quan trọng',
  },
  firstImportantNote: {
    id: `${scope}.firstImportantNote`,
    defaultMessage: 'Chỉ chuyển khoản sau khi đơn hàng đã được giao hoàn tất',
  },
  secondImportantNote: {
    id: `${scope}.secondImportantNote`,
    defaultMessage: 'Với những hóa đơn dưới 400,000đ, Kamereo sẽ tính thêm phụ phí giao hàng là 25,000đ',
  },
  thirdImportantNote: {
    id: `${scope}.thirdImportantNote`,
    defaultMessage:
      'Sử dụng thông tin chuyển khoản chính xác: Đảm bảo tên tài khoản, số tài khoản và nội dung chuyển khoản đúng để xác nhận thanh toán',
  },
  copy: {
    id: `${scope}.copy`,
    defaultMessage: 'Sao chép',
  },
  copySuccess: {
    id: `${scope}.copySuccess`,
    defaultMessage: 'Sao chép thành công',
  },
  copyFail: {
    id: `${scope}.copyFail`,
    defaultMessage: 'Sao chép thất bại',
  },
  qrCode: {
    id: `${scope}.qrCode`,
    defaultMessage: 'Mã QR',
  },
  orderType: {
    id: `${scope}.orderType`,
    defaultMessage: 'Loại đơn hàng',
  },
  giftOrder: {
    id: `${scope}.giftOrder`,
    defaultMessage: 'Đơn hàng quà tặng',
  },
  sampleOrder: {
    id: `${scope}.sampleOrder`,
    defaultMessage: 'Đơn hàng mẫu',
  },
  employeeOrder: {
    id: `${scope}.employeeOrder`,
    defaultMessage: 'Đơn hàng nhân viên',
  },
  normalOrder: {
    id: `${scope}.normalOrder`,
    defaultMessage: 'Đơn hàng thường',
  },
  redeliveryOrder: {
    id: `${scope}.redeliveryOrder`,
    defaultMessage: 'Đơn hàng giao bù',
  },
  subTotal: {
    id: `${scope}.subTotal`,
    defaultMessage: 'Tổng tiền hàng (Trước VAT)',
  },
  editableOrderTooltip: {
    id: `${scope}.editableOrderTooltip`,
    defaultMessage: 'Đơn hàng đang được áp dụng voucher, vui lòng huỷ hoặc đặt lại đơn khác',
  },
  rate: {
    id: `${scope}.rate`,
    defaultMessage: 'Đánh giá',
  },
  reOrder: {
    id: `${scope}.reOrder`,
    defaultMessage: 'Mua lại',
  },
  fulfillmentNote: {
    id: `${scope}.fulfillmentNote`,
    defaultMessage: 'Phiếu giao',
  },
  totalOrder: {
    id: `${scope}.totalOrder`,
    defaultMessage: 'Tổng đơn hàng',
  },
  orderFFMNoteInfo: {
    id: `${scope}.orderFFMNoteInfo`,
    defaultMessage:
      'Phiếu giao hàng {fulfillmentNote} gộp từ các đơn {orderIds}. Vui lòng đối chiếu sản phẩm với phiếu giao hàng hoặc',
  },
  seeHere: {
    id: `${scope}.seeHere`,
    defaultMessage: 'Xem tại đây',
  },
  priceByActualWeight: {
    id: `${scope}.priceByActualWeight`,
    defaultMessage: 'Tiền hàng tính theo cân nặng thực',
  },
  checkFFMNote: {
    id: `${scope}.checkFFMNote`,
    defaultMessage: 'Tổng số tiền đã thay đổi. Vui lòng kiểm tra phiếu giao hàng.',
  },
  note: {
    id: `${scope}.note`,
    defaultMessage: 'Lưu ý:',
  },
  noteText: {
    id: `${scope}.noteText`,
    defaultMessage:
      'Đối với các mặt hàng tính theo trọng lượng, tiền hàng cuối cùng sẽ được điều chỉnh dựa trên trọng lượng thực tế khi giao hàng.',
  },
  seeMore: {
    id: `${scope}.seeMore`,
    defaultMessage: 'Xem thêm',
  },
  hideLess: {
    id: `${scope}.hideLess`,
    defaultMessage: 'Thu gọn',
  },
  decline: {
    id: `${scope}.decline`,
    defaultMessage: 'Không duyệt',
  },
  confirmDeclineOrders: {
    id: `${scope}.confirmDeclineOrders`,
    defaultMessage: 'Bạn có chắc muốn từ chối những đơn hàng đã chọn?',
  },
  submitFeedbackSuccessfully: {
    id: `${scope}.submitFeedbackSuccessfully`,
    defaultMessage: 'Đánh giá phiếu hàng thành công!',
  },
  cancelPerson: {
    id: `${scope}.cancelPerson`,
    defaultMessage: 'Người hủy đơn',
  },
  cancelTime: {
    id: `${scope}.cancelTime`,
    defaultMessage: 'Ngày hủy đơn',
  },
  reloadOrderText: {
    id: `${scope}.reloadOrderText`,
    defaultMessage:
      'Đơn hàng đã được xử lý và không thể huỷ. Khách hàng vui lòng nhấn Xác nhận để tải lại trang và cập nhật trạng thái mới nhất.',
  },
  youHave: {
    id: `${scope}.youHave`,
    defaultMessage: 'Bạn có',
  },
  pendingOrder: {
    id: `${scope}.pendingOrder`,
    defaultMessage: '{count} đơn hàng chờ duyệt.',
  },
  pendingOrderText: {
    id: `${scope}.pendingOrderText`,
    defaultMessage: 'Vui lòng duyệt đơn hàng để tránh ảnh hưởng thời hạn giao hàng.',
  },
  order: {
    id: `${scope}.order`,
    defaultMessage: 'Đơn hàng',
  },
  orders: {
    id: `${scope}.orders`,
    defaultMessage: 'Mã đơn hàng',
  },
  combineText: {
    id: `${scope}.combineText`,
    defaultMessage: 'Các đơn từ cùng cửa hàng có cùng ngày giao sẽ được gộp lại thành một lần giao hàng.',
  },
  sponsorshipOrder: {
    id: `${scope}.sponsorshipOrder`,
    defaultMessage: 'Đơn hàng tài trợ',
  },
  downloadDeliveryNote: {
    id: `${scope}.downloadDeliveryNote`,
    defaultMessage: 'Tải phiếu giao hàng',
  },
  downloadDeliveryNoteFailed: {
    id: `${scope}.downloadDeliveryNoteFailed`,
    defaultMessage: 'Tải phiếu giao hàng thất bại. Vui lòng thử lại.',
  },
  downloadDeliveryNoteSuccess: {
    id: `${scope}.downloadDeliveryNoteSuccess`,
    defaultMessage: 'Tải phiếu giao hàng thành công.',
  },
});
